import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/home";
import RSVP from "./pages/rsvp";
import PageWrapper from "./components/page-wrapper";
import Gallery from "./pages/gallery";
import Loading from "./components/loading";
import useImagePreloader from "./hooks/useImagePreloader";

function App() {
  const coverArtLoaded = useImagePreloader('cover');

  if (!coverArtLoaded) {
    return <Loading />;
  }

  return (
    <Router>
      <ThemeProvider theme={theme}>
        <PageWrapper>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/rsvp" element={<RSVP />} />
            <Route path="/gallery" element={<Gallery />} />
          </Routes>
        </PageWrapper>
      </ThemeProvider>
    </Router>
  );
}

export default App;
